import type { LocationLanguage } from './types'

export const LOCATION_LANGUAGES: LocationLanguage[] = ['pt-BR', 'en', 'es']
